import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormikContext } from 'formik';
import { isEqual } from 'lodash';

import GroupBtnLight from 'modules/shared/Forms/GroupBtnLight';
import { peripheralsSelector } from '../Header/selectors';
import { weigthSelector } from './selectors';
import { getWeightRequest } from './actions';
import { getOrderWeightRequest } from '../FillTrip';

type Props = {
  nameField: string;
  type: 'IN' | 'OUT' | 'ARRAY';
  isDisabled?: boolean;
  mode?: 'kiosk' | 'main';
  load?: any;
};

const WeightBtn: React.FC<Props> = ({ nameField, type, mode = 'main', isDisabled = false, load }) => {
  const dispatch = useDispatch();
  const formik = useFormikContext();
  const { values: tripValue } = useFormikContext();

  const { error, loading, weight, fieldName } = useSelector(weigthSelector);

  const peripherals = useSelector(peripheralsSelector);

  const scalesIn = peripherals?.find(
    (p) => isEqual(p.type, 'Scales') && isEqual(p.processName, 'Entrance'),
  )?.peripheralUrl;
  const scalesOut = peripherals?.find(
    (p) => isEqual(p.type, 'Scales') && isEqual(p.processName, 'Exit'),
  )?.peripheralUrl;

  const onGetWeight = () => {
    if (isEqual(type, 'IN') && scalesIn) return dispatch(getWeightRequest(scalesIn, nameField));
    if (isEqual(type, 'OUT') && scalesOut) return dispatch(getWeightRequest(scalesOut, nameField));
    if (isEqual(type, 'ARRAY')) return dispatch(getOrderWeightRequest(tripValue));
  };

  useEffect(() => {
    if (weight) formik.setFieldValue(fieldName, weight);
  }, [weight]);

  return (
    <GroupBtnLight
      loading={load || loading}
      // @ts-ignore
      errorMsg={error ? error.message : ''}
      isField={nameField}
      isLoadingField={fieldName}
      onClick={onGetWeight}
      disabled={!peripherals?.length || isDisabled}
      btnIcon="weight"
      mode={mode}
    />
  );
};

export default WeightBtn;
